__webpack_require__.p = "https://admin-panel.winlocal.com/";